import { Injectable } from "@angular/core";
import { ApiService } from "@api/core";
import * as moment from "moment";
import { Observable } from "rxjs";
import { BasicaAnthropometricReport, ComparativeVsReferencialReport, ExecuteActionDto, ExecuteRenewalActionDto, PatientMultipleReportRecord, RenewalState, ReportClinico, ScreenningReportDataDTO, SuscriptionState, SuscriptionSummaryDTO, TimelineReport } from './reports.model';
import { RowGridReportFA5CDTOList } from '@api/patient/evaluation/models/rowGridReportFA5CDTOList';
import { HttpClient } from "@angular/common/http";
import { UserApiService } from "@api/user";

const API_URL = "report_data";
const API_URL_USERS = "user";
const API_URL_JOBS = 'jobs'

export enum typeState {
  APROVE = "APROVE",
  REFUND = "REFUND",
}

@Injectable()
export class ReportApiService {
  constructor(
    private api: ApiService,
    private http: HttpClient,
    private userService: UserApiService,
  ) { }
  public selectedIdEvaluation: string = ''


  putChangeStateSuscription(actionEnum: string, selectedSuscriptions: number[]): Observable<ExecuteActionDto> {
    return this.api.put<ExecuteActionDto>(API_URL_JOBS, '/susciption', {
      actionEnum: actionEnum,
      selectedSuscriptions: selectedSuscriptions
    })

  }

  getStateSuscription(state: string): Observable<SuscriptionState> {
    return this.api.get<SuscriptionState>(API_URL_USERS, `/suscriptions?state=${state}`);
  }

  getRenewals(state?: string): Observable<RenewalState> {
    const query = state ? `?state=${encodeURIComponent(state)}` : '';
    return this.api.get<RenewalState>(API_URL_USERS, `/suscription/renewals${query}`);
  }

  putRenewalAction(actionEnum: 'APPROVE' | 'DENY', selectedRenewals: number[]): Observable<ExecuteRenewalActionDto> {
    return this.api.put<ExecuteRenewalActionDto>(API_URL_JOBS, '/susciption/renewal-action', {
      actionEnum,
      selectedRenewals,
    });
  }

  getRowGridReportFA5CDTOList(
    patientId: number,
    instituteId: string,
    selectedEvaluation: string
  ): Observable<RowGridReportFA5CDTOList> {
    return this.api.get<RowGridReportFA5CDTOList>(
      API_URL,
      `/objetive?instituteId=${instituteId}&patientId=${patientId}&selectedIdEvaluation=${selectedEvaluation}`
    )
  }

  getPatientBasicaAnthropometricReport(
    patientId: number,
    selectedEvaluation: string,
    instituteId: string
  ): Observable<BasicaAnthropometricReport> {
    return this.api.get<BasicaAnthropometricReport>(
      API_URL,
      `/fa5c/basic-anthopometric?instituteId=${instituteId}&patientId=${patientId}&selectedIdEvaluation1=${selectedEvaluation}`
    );
  }

  getPatientReportClinico(
    patientId: number,
    instituteId: string,
    selectedIdEvaluation: string,
  ): Observable<ReportClinico> {
    return this.api.get<ReportClinico>(
      API_URL,
      `/clinical-report?patientId=${patientId}&instituteId=${instituteId}&selectedIdEvaluation=${selectedIdEvaluation}`
    )
  }

  getPatientScreenninSimpleReport(
    patientId: number,
    instituteId: string,
    evaluations: string[]
  ): Observable<ScreenningReportDataDTO> {
    return this.api.get<ScreenningReportDataDTO>(
      API_URL,
      `/fa5c/simple-screenning-report?instituteId=${instituteId}&patientId=${patientId}&selectedIdEvaluation1=${evaluations[0]}`
    );
  }

  getPatientComparativeReport(
    patientId: number,
    instituteId: string,
    evaluations: string[]
  ): Observable<any> {
    return this.api.get<BasicaAnthropometricReport>(
      API_URL,
      `/fa5c/comparative-report?instituteId=${instituteId}&patientId=${patientId}&selectedIdEvaluation1=${evaluations[0]}&selectedIdEvaluation2=${evaluations[1]}`
    );
  }

  getTimelineReport(
    patientId: number,
    instituteId: string,
    dates: any[]
  ): Observable<any> {
    return this.api.get<TimelineReport>(
      API_URL,
      `/fa5c/timeline-report?instituteId=${instituteId}&patientId=${patientId}&sinceDate=${dates[0]}&toDate=${dates[1]}`
    );
  }

  getTimelineReportFac2c(
    patientId: number,
    instituteId: string,
    dates: any[]
  ): Observable<any> {
    return this.api.get<TimelineReport>(
      API_URL,
      `/fa2c/timeline-report?instituteId=${instituteId}&patientId=${patientId}&sinceDate=${dates[0]}&toDate=${dates[1]}`
    );
  }

  getMultiplePersonReportFa5C(segmentId: number, fromDate: moment.Moment | string, toDate: moment.Moment | string): Observable<PatientMultipleReportRecord[]> {
    const from = moment(fromDate).format("YYYY-MM-DD");
    const to = moment(toDate).format("YYYY-MM-DD");
    return this.api.get<PatientMultipleReportRecord[]>(
      API_URL,
      `/fa5c/people-comparer?segmentId=${segmentId}&fromDate=${from}&toDate=${to}`
    );
  }

  getDataSuscriptionAccount(): Observable<SuscriptionSummaryDTO> {
    return this.api.get<SuscriptionSummaryDTO>(
      API_URL_JOBS,
      `/susciption/account/${Number(this.userService.institutionId)}`
    );
  }

}
